import { makeGuardedModal } from 'components/guardedModal/makeGuardedModal';
import { ReviewModalContentContainer } from './ReviewModalContentContainer';
import { SimpleModalId } from 'constants/modalId';

export const ReviewModal = makeGuardedModal(SimpleModalId.ParticipantReview, ReviewModalContentContainer);
